import MaestroLogo from "../assets/images/maestro-logo.png";

export function Header() {
  return (
    <header>
      <img src={MaestroLogo} alt="MaestroConference" />
    </header>
  );
}
